import {
  BoosterDtoTypeEnum,
  PopulatedCampaignUserDto,
  PopulatedCampaignUserDtoStatusEnum,
} from '@coretava/api/ecommerce-service';
import React from 'react';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { observer } from 'mobx-react';
import Campaign from './Campaign';

type Props = {
  campaignUser: PopulatedCampaignUserDto,
  textAlign?: 'center' | 'left'
}

const CampaignUser: React.FC<Props> = ({
  campaignUser,
  textAlign,
}) => {
  const showCampaignUser = React.useMemo(
    () => [PopulatedCampaignUserDtoStatusEnum.Pending, PopulatedCampaignUserDtoStatusEnum.Valid]
      .some((stat) => stat === campaignUser.status) ||
   (campaignUser.campaign.booster?.type === BoosterDtoTypeEnum.Referal && !CampaignUserStore.refereeCampaignUser?.converted),
    [campaignUser, CampaignUserStore.refereeCampaignUser],
  );

  const campaignDiscount = React.useMemo(() => CampaignUserStore.getCampaignDiscount(campaignUser), [campaignUser, CampaignUserStore.campaignsDiscounts]);

  if (!showCampaignUser) return null;

  return (
    <Campaign campaign={campaignUser.campaign} discount={campaignDiscount} textAlign={textAlign} status={campaignUser.status} />
  );
};

export default observer(CampaignUser);
